import React, { useState, useEffect } from 'react' //, useCallback
import { Link } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'
import { useSelector } from 'react-redux'
import CustomerSiteTreeView from '../Components/CustomerSiteTreeView.jsx'
import CustomerTags from '../Components/CustomerTags.jsx'
import CustomerTag from '../Components/CustomerTag.jsx'
import '../../themes/default-button-blue/Default-Button-Blue.scss'
import TagUIDSelect from '../Components/TagUIDSelect.jsx'
import { Splitter } from '@progress/kendo-react-layout'
import InsightLogo from '../Images/Insight.png'
import UserGuideLogo from '../Images/UserGuide.png'
import UserGuide from '../docs/INSIGHT 1.5 User Guide.pdf'
import '../../fonts.css'
import '.././LCMForms.css'
import { NotificationManager } from '../../GlobalComponents/NotificationManager/NotificationManager'
import { MobileAssetView } from './MobileAssetView'

let qsSearch = window.location.search
let qsParams = new URLSearchParams(qsSearch)
let qsTagUID = qsParams.get('u')
let qsODID = qsParams.get('od')
let qsTarId = qsParams.get('tar')

// function getWindowDimensions() {
//   const { innerWidth: width, innerHeight: height } = window;
//   return {
//     width,
//     height
//   };
// }

function EntitySite(Site) {
    this.Site = Site
}

function EntitySites(EntityName) {
    this.EntityName = EntityName
    this.AllSites = false
    this.Sites = []
    this.add = function (EntitySite) {
        this.Sites.push(EntitySite)
    }
}

function Entities() {
    this.Entities = []
    this.AllSites = false
    this.add = function (EntitySites) {
        this.Entities.push(EntitySites)
    }
}

export const HomePage = () => {
    document.title = 'Life Cycle Management'
    //const isDesktopOrLaptop = useMediaQuery({query: '(min-device-width: 1224px)'});
    //const isDesktopOrLaptop = useMediaQuery({query: '(min-device-width: 400px)'});
    const isSmall = useMediaQuery({ maxWidth: 1000 })
    const isOldDesktop = useMediaQuery({ maxWidth: 1280 })
    // const isBigScreen = useMediaQuery({ query: '(min-device-width: 1824px)' });
    // const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
    // const isTabletOrMobileDevice = useMediaQuery({query: '(max-device-width: 1224px)'});
    // const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });
    // const isRetina = useMediaQuery({ query: '(min-resolution: 2dppx)' });
    const [customerTagsCriteria, setCustomerTagsCriteria] = useState({
        SelectedCustomerSites: [],
        SelectedCustomerTags: [],
        SelectedOrderTagIds: [],
        SelectedAssetType: { ID: -1, Name: '' },
        SelectedOrderDetailId: -1,
    })
    const [customerTagFilters] = useState({
        TagUID: qsTagUID,
        ProjectID: qsTarId,
    })
    const assetSelected = useSelector((state) => state.assetSelectReducer.assetSelected)
    //const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const entityMaxPixels = useSelector((state) => state.customerTreeViewReducer.entityMaxPixels)

    const [panesTLTags, setPanesTLTags] = useState([
        {
            size: '23%',
            min: '20px',
            resizable: true,
            collapsible: true,
            keepMounted: true,
            scrollable: true,
        },
        {},
        { min: '20px', resizable: true, collapsible: false, scrollable: false },
    ])

    useEffect(() => {
        let usableEntityMaxPixels = entityMaxPixels
        if (isOldDesktop && entityMaxPixels > 280) usableEntityMaxPixels = 280
        let customerSiteTreePanelSize = (60 + usableEntityMaxPixels).toString() + 'px'
        if (entityMaxPixels === 0) customerSiteTreePanelSize = '23%'
        setPanesTLTags([
            {
                size: customerSiteTreePanelSize,
                min: '20px',
                resizable: true,
                collapsible: true,
                keepMounted: true,
                scrollable: true,
            },
            {},
            { min: '20px', resizable: true, collapsible: false, scrollable: false },
        ])
    }, [isOldDesktop, entityMaxPixels])

    const [orderTagID, setOrderTagID] = useState(-1)
    const [tagWindowVisible, setTagWindowVisible] = useState(qsTagUID === null ? false : true)
    const [isViewOrderDetailOnly, setIsViewOrderDetailOnly] = useState(false)

    useEffect(() => {
        setIsViewOrderDetailOnly(qsODID !== null && !isNaN(qsODID) && parseInt(qsODID) > 0)
    }, [qsODID])

    useEffect(() => {
        if (!isViewOrderDetailOnly) return

        setCustomerTagsCriteria({
            SelectedCustomerSites: customerTagsCriteria.SelectedCustomerSites,
            SelectedCustomerTags: customerTagsCriteria.SelectedCustomerTags,
            SelectedOrderTagIds: customerTagsCriteria.SelectedOrderTagIds,
            SelectedAssetType: customerTagsCriteria.SelectedAssetType,
            SelectedOrderDetailId: parseInt(qsODID),
        })
    }, [isViewOrderDetailOnly])

    // Rely on Chrome's message... our's will NOT be shown!
    const isDirty = useSelector((state) => state.appReducer.isDirty)
    // useEffect(() => {
    //     // Detecting browser closing
    //     window.onbeforeunload =
    //         isDirty && (() => 'Are you sure you want to leave this site and lose your settings?')
    //     return () => {
    //         window.onbeforeunload = null
    //     }
    // }, [isDirty])

    // // Handle viewport dimensions
    // useEffect(() => {
    //   function handleResize() {
    //     setWindowDimensions(getWindowDimensions());
    //   }
    //   window.addEventListener("resize", handleResize);
    //   return () => window.removeEventListener("resize", handleResize);
    // }, []);

    function getEntityIndex(arr, value) {
        let EntityIndex = -1
        for (var i = 0, iLen = arr.length; i < iLen; i++) {
            if (arr[i].EntityName === value) return i
        }
        return EntityIndex
    }

    //const handleCustomerSiteTreeViewCheck = useCallback((checks) => {
    function handleCustomerSiteTreeViewCheck(checks) {
        //Format of "checks":  Tree Level (0-2) | Entity | Site
        let checkedEntities = new Entities()
        //Scan checks to see if all Entities/Sites are selected (ie level 0 exists in checks)
        for (var index in checks.ids) {
            let checksArray = checks.ids[index].split('|')
            if (checksArray[0] === '0') {
                checkedEntities.AllSites = true
                break
            }
        }

        // Load Entities
        if (!checkedEntities.AllSites) {
            for (index in checks.ids) {
                let checksArray = checks.ids[index].split('|')
                let checksEntityName = checksArray[1]
                if (getEntityIndex(checkedEntities.Entities, checksEntityName) === -1) {
                    let checkedEntitySites = new EntitySites()
                    checkedEntitySites.EntityName = checksEntityName
                    checkedEntities.add(checkedEntitySites)
                }
                // if no particular site listed then set the AllSites flag
                if (checksArray.length < 3) {
                    let i = getEntityIndex(checkedEntities.Entities, checksEntityName)
                    checkedEntities.Entities[i].AllSites = true
                }
            }

            // For Partial Entities, load specific Sites into Entities
            for (index in checks.ids) {
                let checksArray = checks.ids[index].split('|')
                if (checksArray.length > 2) {
                    let checksEntityName = checksArray[1]
                    let i = getEntityIndex(checkedEntities.Entities, checksEntityName)
                    if (!checkedEntities.Entities[i].AllSites) {
                        let checkedSite = new EntitySite(checksArray[2] + ', ' + checksArray[3]) // City & State
                        checkedEntities.Entities[i].add(checkedSite)
                    }
                }
            }
        }
        setTagWindowVisible(false)
        setCustomerTagsCriteria({
            SelectedCustomerSites: checkedEntities,
            SelectedCustomerTags: customerTagsCriteria.SelectedCustomerTags,
            SelectedOrderTagIds: customerTagsCriteria.SelectedOrderTagIds,
            SelectedAssetType: customerTagsCriteria.SelectedAssetType,
            SelectedOrderDetailId: customerTagsCriteria.SelectedOrderDetailId,
        })
    } //,[customerTagsCriteria.SelectedCustomerTags, customerTagsCriteria.SelectedAssetType]);

    function handleTagUIDSelectChange(Tags, OrderTagIds) {
        setTagWindowVisible(false)
        setCustomerTagsCriteria({
            SelectedCustomerSites: customerTagsCriteria.SelectedCustomerSites,
            SelectedCustomerTags: Tags,
            SelectedAssetType: customerTagsCriteria.SelectedAssetType,
            SelectedOrderTagIds: OrderTagIds,
            SelectedOrderDetailId: customerTagsCriteria.SelectedOrderDetailId,
            searchedTagUID: Tags.length === 1 ? Tags[0] : undefined,
        })
    }

    function handleTLTagsPanesChange(event) {
        setPanesTLTags(event.newState)
    }

    function closeDialog() {
        setTagWindowVisible(false)
        qsTagUID = null // clear query string... user has viewed tag
        //set orderTagID to -1 to allow reopenning of same tag
        setOrderTagID(-1)
    }

    function handleRowClick(event) {
        setOrderTagID(event.dataItem.OrderTagId)
        setTagWindowVisible(true)
    }

    if (assetSelected !== customerTagsCriteria.SelectedAssetType) {
        setCustomerTagsCriteria({
            SelectedCustomerSites: customerTagsCriteria.SelectedCustomerSites,
            SelectedCustomerTags: customerTagsCriteria.SelectedCustomerTags,
            SelectedOrderTagIds: customerTagsCriteria.SelectedOrderTagIds,
            SelectedAssetType: assetSelected,
            SelectedOrderDetailId: customerTagsCriteria.SelectedOrderDetailId,
        })
    }

    // Temporarily removing StrictMode from Index.js to get Kendo's Grid Column Resizer to work.owVisible.toString()
    // + " Window: " + windowDimensions.width + "W X " +
    //             windowDimensions.height + "H");

    const [isMobileAssetView, setIsMobileAssetView] = useState(false)
    const handleMobileAssetView = (bool) => {
        setIsMobileAssetView(bool)
    }

    if (isMobileAssetView || (!tagWindowVisible && isSmall)) {
        return (
            <div className="lcmForms">
                <MobileAssetView handleMobileAssetView={handleMobileAssetView} />
            </div>
        )
    }

    return (
        <div className="lcmForms">
            {!isSmall && (
                // {!tagWindowVisible && !isSmall && (
                <div className={`mainContainer${isViewOrderDetailOnly ? ' orderDetailOnly' : ''}`}>
                    <div>
                        <img className="headerLogo" src={InsightLogo} alt="Life Cycle Management" />
                    </div>
                    <div className="headerTitle">
                        Life Cycle
                        <br />
                        Management
                    </div>
                    {isViewOrderDetailOnly ?
                        <div className="customerTagsPanel">
                            <CustomerTags
                                CustomerTagsCriteria={customerTagsCriteria}
                                CustomerTagFilters={customerTagFilters}
                                onRowClick={handleRowClick}
                            />
                        </div> :
                        <>
                            <div className="headerSearch">
                                <div style={{ padding: '20px 0px 0px 10px' }}>Search</div>
                                <div style={{ padding: '15px 0px 0px 10px' }}>
                                    <TagUIDSelect onChange={handleTagUIDSelectChange} />
                                </div>
                            </div>
                            {/* <div className="headerLinks">
                                    <div
                                        style={{
                                        width: "100%",
                                        padding: "23px 5px 0px 0px",
                                        textAlign: "right",
                                        }}
                                    >
                                        <nav>
                                        <Link
                                            to="/lcmforms/ShopMonitor"
                                            style={{
                                            color: "#66A4FF",
                                            textDecoration: "none",
                                            fontSize: 14,
                                            }}
                                        >
                                            Shop Monitor
                                        </Link>
                                        </nav>
                                    </div>
                                </div> */}

                            <div className="headerGuides">
                                <div
                                    title="User Guide"
                                    style={{
                                        width: '100%',
                                        padding: '14px 5px 0px 0px',
                                        textAlign: 'right',
                                    }}
                                >
                                    <a href={UserGuide} target="_blank" rel="noreferrer">
                                        <img src={UserGuideLogo} alt="Insight User Guide" />
                                    </a>
                                </div>
                            </div>
                            {!isSmall && (
                                <Splitter
                                    orientation="horizontal"
                                    panes={panesTLTags}
                                    className="tvtlSplitter"
                                    onChange={handleTLTagsPanesChange}
                                >
                                    <div>
                                        <CustomerSiteTreeView
                                            className="customerSiteTreePanel"
                                            onCustTVCheck={handleCustomerSiteTreeViewCheck}
                                        />
                                    </div>
                                    <div className="customerTagsPanel" style={{ height: 'inherit' }}>
                                        <CustomerTags
                                            CustomerTagsCriteria={customerTagsCriteria}
                                            CustomerTagFilters={customerTagFilters}
                                            onRowClick={handleRowClick}
                                        />
                                    </div>
                                </Splitter>
                            )}
                            {isSmall && (
                                <>
                                    <div className="customerTagsPanel">
                                        <CustomerTags
                                            CustomerTagsCriteria={customerTagsCriteria}
                                            CustomerTagFilters={customerTagFilters}
                                            onRowClick={handleRowClick}
                                        />
                                    </div>
                                    <div>
                                        <CustomerSiteTreeView
                                            className="customerSiteTreePanel"
                                            onCustTVCheck={handleCustomerSiteTreeViewCheck}
                                        />
                                    </div>
                                </>
                            )}
                        </>}
                </div>
            )}

            <div>
                {tagWindowVisible && (
                    <CustomerTag
                        orderTagID={orderTagID}
                        onClose={closeDialog}
                        // tagWindowVisible={tagWindowVisible}
                        handleMobileAssetView={handleMobileAssetView}
                    />
                )}
                <NotificationManager key={'notificationsManager'} />
            </div>
        </div>
    )
}
